import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
export default {
  name: "MediumRecordLog",
  data: function data() {
    return {
      visible: false
    };
  },
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rentList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    rentTypeName: function rentTypeName(val) {
      var _this$rentList$filter;
      return ((_this$rentList$filter = this.rentList.filter(function (item) {
        return item.id === val;
      })) === null || _this$rentList$filter === void 0 || (_this$rentList$filter = _this$rentList$filter[0]) === null || _this$rentList$filter === void 0 ? void 0 : _this$rentList$filter.name) || "";
    },
    previewImage: function previewImage(arr, imgIndex) {
      var _this = this;
      this.$nextTick(function () {
        _this.$hevueImgPreview({
          multiple: true,
          nowImgIndex: imgIndex || 0,
          imgList: arr
        });
      });
    }
  },
  computed: {
    reverseList: function reverseList() {
      if (!this.list.length) return [];
      var arr = JSON.parse(JSON.stringify(this.list));
      return arr.length ? arr.reverse() : [];
    },
    disabled: function disabled() {
      return this.list.length < 2;
    },
    // 获取list倒数第二个数据的images
    secondLastImages: function secondLastImages() {
      if (this.list.length < 2) {
        return [];
      }
      return this.list[this.list.length - 2].images || [];
    },
    // 比较倒数第二个数据的images与当前house的imgs是否一致
    isImagesChanged: function isImagesChanged() {
      var _this$info;
      if (this.disabled || !((_this$info = this.info) !== null && _this$info !== void 0 && (_this$info = _this$info.imgs) !== null && _this$info !== void 0 && _this$info.length)) {
        return false;
      }
      var currents = this.info.imgs || [];
      //是否全部不同
      var isIdentical = this.secondLastImages.some(function (i) {
        return currents.includes(i);
      });
      return !isIdentical;
    }
  }
};